import { useMemo } from 'react';
import { useUniversityData, UniversityData } from '../services/universityService';

interface TransformedPrompt {
  prompt: string;
  wordCount: string;
  status: string;
  supplement_id: number;
  prompt_id: number;
  category: string;
}

interface UseUniversityPromptsResult {
  universityData: UniversityData | undefined;
  isLoading: boolean;
  error: any;
}

export const useUniversityPrompts = (universityId: number): UseUniversityPromptsResult => {
  const { data: universityData, isLoading: universityLoading, error: universityError } = useUniversityData(universityId);

  return {
    universityData,
    isLoading: universityLoading,
    error: universityError
  };
};
